import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
} from '../core/ReactiveState.mjs';
import { await1kke5zj2piplv as await_0 } from './DependencyChangeListener.mjs';
import {
  equals2au1ep9vhcato as equals,
  boxApply1qmzdb3dh90hg as boxApply,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  onRemove3k528udkni1ni as onRemove,
  Key_instance6wd16m35aua5 as Key_instance,
} from './CalculationContext.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ReactiveLoadings35224pps2d9 as ReactiveLoading } from './ReactiveContext.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../core/signals.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Key_getInstance2js7sv2agqob1 as Key_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import {
  CoroutineStart_DEFAULT_getInstance2bbgmtawlnkke as CoroutineStart_DEFAULT_getInstance,
  CoroutineStart_UNDISPATCHED_getInstance1s89xhsoy2cne as CoroutineStart_UNDISPATCHED_getInstance,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, value, $completion) {
  var tmp = $this.fah_1.gah(value, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, value, $completion) {
  var tmp = $this.hah_1.gah(value, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  $this.iah_1._v.pah(Companion_getInstance().mah_1);
  var tmp = $this.iah_1._v;
  // Inline function 'com.lightningkite.reactive.core.reactiveState' call
  var tmp_0;
  try {
    var tmp_1 = await_0($this.jah_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var intendedValue = {_v: tmp_1};
    var tmp_2 = $this.kah_1.gah(intendedValue._v, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var setReplica = oneAtATime($this.lah_1, false, CoroutineScopeHelpers$bind$slambda$slambda_0($this.kah_1));
    var setMaster = oneAtATime($this.lah_1, true, CoroutineScopeHelpers$bind$slambda$slambda_2($this.jah_1));
    // Inline function 'kotlin.also' call
    var this_0 = $this.jah_1.tah(() => {
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
      var this_0 = $this.jah_1.qah();
      var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
      var tmp;
      if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
        tmp = null;
      } else {
        if (tmp0_subject instanceof InternalReactiveThrownException()) {
          _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
          tmp = null;
        } else {
          if (tmp0_subject instanceof InternalReactiveWrapper()) {
            var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
            var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
            if (!equals(intendedValue._v, it)) {
              intendedValue._v = it;
              setReplica(it);
            }
            tmp = Unit_instance;
          } else {
            var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
            if (!equals(intendedValue._v, it_0)) {
              intendedValue._v = it_0;
              setReplica(it_0);
            }
            tmp = Unit_instance;
          }
        }
      }
      return Unit_instance;
    });
    onRemove($this.lah_1, this_0);
    // Inline function 'kotlin.also' call
    var this_1 = $this.kah_1.tah(() => {
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
      var this_0 = $this.kah_1.qah();
      var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
      var tmp;
      if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
        tmp = null;
      } else {
        if (tmp0_subject instanceof InternalReactiveThrownException()) {
          _ReactiveState___get_raw__impl__92ipya(this_0).sah_1;
          tmp = null;
        } else {
          if (tmp0_subject instanceof InternalReactiveWrapper()) {
            var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).rah_1;
            var it = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
            if (!equals(intendedValue._v, it)) {
              intendedValue._v = it;
              setMaster(it);
            }
            tmp = Unit_instance;
          } else {
            var it_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
            if (!equals(intendedValue._v, it_0)) {
              intendedValue._v = it_0;
              setMaster(it_0);
            }
            tmp = Unit_instance;
          }
        }
      }
      return Unit_instance;
    });
    onRemove($this.lah_1, this_1);
    tmp_0 = _ReactiveState___init__impl__fvdp9b(Unit_instance);
  } catch ($p) {
    var tmp_3;
    if ($p instanceof CancellationException()) {
      var _unused_var__etf5q3 = $p;
      tmp_3 = Companion_getInstance().mah_1;
    } else {
      if ($p instanceof ReactiveLoading()) {
        var _unused_var__etf5q3_0 = $p;
        tmp_3 = Companion_getInstance().mah_1;
      } else {
        if ($p instanceof Exception()) {
          var e = $p;
          tmp_3 = Companion_getInstance().uah(e);
        } else {
          throw $p;
        }
      }
    }
    tmp_0 = tmp_3;
  }
  var tmp$ret$21 = tmp_0;
  tmp.pah(tmp$ret$21);
  return Unit_instance;
}
var CoroutineScopeHelpers$bind$slambda$slambdaClass;
function CoroutineScopeHelpers$bind$slambda$slambda() {
  if (CoroutineScopeHelpers$bind$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_bind) {
        this.fah_1 = $this_bind;
      }
      vah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, value), $completion);
      }
      s2(p1, $completion) {
        return this.vah((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CoroutineScopeHelpers$bind$slambda$slambdaClass = $;
  }
  return CoroutineScopeHelpers$bind$slambda$slambdaClass;
}
function CoroutineScopeHelpers$bind$slambda$slambda_0($this_bind) {
  var i = new (CoroutineScopeHelpers$bind$slambda$slambda())($this_bind);
  var l = (value, $completion) => i.vah(value, $completion);
  l.$arity = 1;
  return l;
}
var CoroutineScopeHelpers$bind$slambda$slambdaClass_0;
function CoroutineScopeHelpers$bind$slambda$slambda_1() {
  if (CoroutineScopeHelpers$bind$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($master) {
        this.hah_1 = $master;
      }
      vah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, value), $completion);
      }
      s2(p1, $completion) {
        return this.vah((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CoroutineScopeHelpers$bind$slambda$slambdaClass_0 = $;
  }
  return CoroutineScopeHelpers$bind$slambda$slambdaClass_0;
}
function CoroutineScopeHelpers$bind$slambda$slambda_2($master) {
  var i = new (CoroutineScopeHelpers$bind$slambda$slambda_1())($master);
  var l = (value, $completion) => i.vah(value, $completion);
  l.$arity = 1;
  return l;
}
var CoroutineScopeHelpers$bind$slambdaClass;
function CoroutineScopeHelpers$bind$slambda() {
  if (CoroutineScopeHelpers$bind$slambdaClass === VOID) {
    class $ {
      constructor($reportTo, $master, $this_bind, this$0) {
        this.iah_1 = $reportTo;
        this.jah_1 = $master;
        this.kah_1 = $this_bind;
        this.lah_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CoroutineScopeHelpers$bind$slambdaClass = $;
  }
  return CoroutineScopeHelpers$bind$slambdaClass;
}
function CoroutineScopeHelpers$bind$slambda_0($reportTo, $master, $this_bind, this$0) {
  var i = new (CoroutineScopeHelpers$bind$slambda())($reportTo, $master, $this_bind, this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var CoroutineScopeHelpersClass;
function CoroutineScopeHelpers() {
  if (CoroutineScopeHelpersClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
      }
      xah(_this__u8e3s4, master) {
        var reportTo = {_v: RawReactive().yah(_ReactiveState___init__impl__fvdp9b(Unit_instance))};
        var tmp0_safe_receiver = this.ea2().cd(Key_instance);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cah(reportTo._v);
        }
        launch(this, VOID, VOID, CoroutineScopeHelpers$bind$slambda_0(reportTo, master, _this__u8e3s4, this));
      }
    }
    initMetadataForClass($, 'CoroutineScopeHelpers', VOID, VOID, [CoroutineScope()]);
    CoroutineScopeHelpersClass = $;
  }
  return CoroutineScopeHelpersClass;
}
function oneAtATime(_this__u8e3s4, work, action) {
  var lastJob = {_v: null};
  var reportTo = {_v: RawReactive().yah(_ReactiveState___init__impl__fvdp9b(Unit_instance))};
  if (work) {
    var tmp0_safe_receiver = _this__u8e3s4.ea2().cd(Key_instance);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dah(reportTo._v);
    }
  } else {
    var tmp1_safe_receiver = _this__u8e3s4.ea2().cd(Key_instance);
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.cah(reportTo._v);
    }
  }
  return (it) => {
    var tmp0_safe_receiver = lastJob._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ma3();
    }
    // Inline function 'kotlin.let' call
    var tmp0 = _this__u8e3s4;
    var tmp$ret$0;
    $l$block_0: {
      var done = {_v: false};
      var tmp;
      var tmp0_safe_receiver_0 = tmp0.ea2().cd(Key_getInstance());
      if ((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.qa8(tmp0.ea2())) === false) {
        tmp = CoroutineStart_UNDISPATCHED_getInstance();
      } else {
        tmp = CoroutineStart_DEFAULT_getInstance();
      }
      var tmp_0 = tmp;
      var job = launch(tmp0, VOID, tmp_0, oneAtATime$lambda$slambda_0(action, it, done, reportTo));
      if (done._v) {
        tmp$ret$0 = null;
        break $l$block_0;
      } else {
        reportTo._v.pah(Companion_getInstance().mah_1);
        tmp$ret$0 = job;
        break $l$block_0;
      }
    }
    var tmp$ret$1 = tmp$ret$0;
    lastJob._v = tmp$ret$1;
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.core.reactiveState' call
  var tmp;
  try {
    var tmp_0 = $this.zah_1($this.aai_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = _ReactiveState___init__impl__fvdp9b(Unit_instance);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof CancellationException()) {
      var _unused_var__etf5q3 = $p;
      tmp_1 = Companion_getInstance().mah_1;
    } else {
      if ($p instanceof ReactiveLoading()) {
        var _unused_var__etf5q3_0 = $p;
        tmp_1 = Companion_getInstance().mah_1;
      } else {
        if ($p instanceof Exception()) {
          var e = $p;
          tmp_1 = Companion_getInstance().uah(e);
        } else {
          throw $p;
        }
      }
    }
    tmp = tmp_1;
  }
  var result = tmp;
  $this.bai_1._v = true;
  $this.cai_1._v.pah(result);
  return Unit_instance;
}
var oneAtATime$lambda$slambdaClass;
function oneAtATime$lambda$slambda() {
  if (oneAtATime$lambda$slambdaClass === VOID) {
    class $ {
      constructor($action, $it, $done, $reportTo) {
        this.zah_1 = $action;
        this.aai_1 = $it;
        this.bai_1 = $done;
        this.cai_1 = $reportTo;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    oneAtATime$lambda$slambdaClass = $;
  }
  return oneAtATime$lambda$slambdaClass;
}
function oneAtATime$lambda$slambda_0($action, $it, $done, $reportTo) {
  var i = new (oneAtATime$lambda$slambda())($action, $it, $done, $reportTo);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  CoroutineScopeHelpers as CoroutineScopeHelpers1j3li0lv9e54a,
};
//endregion

//# sourceMappingURL=CoroutineScopeHelpers.mjs.map
